import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, InjectionToken } from "@angular/core";
import { CaseDataFilter } from "@vp/data-access-case-filter";
import { CaseStatusCount } from "@vp/models";
import { Observable } from "rxjs";

export const CASE_SUMMARY_API_BASE_URL = new InjectionToken<string>("API_BASE_URL");

@Injectable({
  providedIn: "root"
})
export class CaseSummaryService {
  constructor(
    @Inject(CASE_SUMMARY_API_BASE_URL) private _apiBaseUrl: string,
    private readonly _http: HttpClient
  ) {}

  getCaseStatusCountsForCurrentUser = (): Observable<CaseStatusCount[]> => {
    const apiURL = `${this._apiBaseUrl}/casesummary?filter=active`;
    return this._http.get<CaseStatusCount[]>(apiURL);
  };
  getCaseStatusCounts = (filter: Partial<CaseDataFilter>): Observable<CaseStatusCount[]> => {
    const params: Record<string, any> = {};

    if (filter.search) {
      params.search = filter.search;
    }

    if (filter.tagIds?.length) {
      params.tag = filter.tagIds;
    }

    if (filter.status?.length) {
      params.status = filter.status;
    }

    if (filter.caseTypeIds?.length) {
      params.filter = `caseType.caseTypeId=${filter.caseTypeIds.join(",")}`;
    }
    return this._http.get<CaseStatusCount[]>(`${this._apiBaseUrl}/casesummary`, { params });
  };
}
